module.exports = __webpack_public_path__ + "media/images/pt/nurture_growth-98f92e6d0860430dbb72ca8ccedffe50.png";